import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row", "empty"]

  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let visibleCount = 0

    this.rowTargets.forEach(row => {
      if (query === "") {
        row.style.display = ""
        return
      }

      const accountName = (row.dataset.accountName || "").toLowerCase()
      const displayName = (row.dataset.displayName || "").toLowerCase()
      const keyword = (row.dataset.keyword || row.dataset.keywordName || "").toLowerCase()

      const matches = accountName.includes(query) || displayName.includes(query) || keyword.includes(query)
      row.style.display = matches ? "" : "none"
      if (matches) visibleCount++
    })

    // 「該当なし」行は任意。置いていない一覧(既存の大半)では何もしない
    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", query === "" || visibleCount > 0)
    }
  }
}
